import { PostHogConfig } from "posthog-js";
import {
  PostHogProvider as PostHogProviderRoot,
  usePostHog,
} from "posthog-js/react";
import { useEffect } from "react";

import { User } from "@oneleet/api_client";

const PostHogProvider = ({
  apiKey,
  apiHost,
  tenant,
  user,
  settings,
  location,
  children,
}: {
  apiKey: string;
  apiHost: string;
  // Explicitly require specifying the tenant or null so that it is only omitted intentionally when not relevant
  tenant: string | null;
  // Explicitly require specifying the user or null so that it is only omitted intentionally when not relevant
  user: User | null;
  settings?: Partial<PostHogConfig>;
  location: string;
  children: React.ReactNode;
}) => {
  const posthog = usePostHog();

  useEffect(() => {
    if (posthog) {
      if (user) {
        const storedUserId = localStorage.getItem("posthog_user_id");
        const storedUserEmail = localStorage.getItem("posthog_user_email");

        if (user.id !== storedUserId || user.email !== storedUserEmail) {
          posthog.identify(user.id, {
            email: user.email,
          });
          localStorage.setItem("posthog_user_id", user.id);
          localStorage.setItem("posthog_user_email", user.email);
        }
      } else {
        posthog.reset();
        localStorage.removeItem("posthog_user_id");
        localStorage.removeItem("posthog_user_email");
      }
    }
  }, [posthog, user]);

  useEffect(() => {
    if (tenant && posthog) {
      const storedTenant = localStorage.getItem("posthog_tenant");

      if (tenant !== storedTenant) {
        posthog?.group("tenant", tenant);
        localStorage.setItem("posthog_tenant", tenant);
      }
    }
  }, [posthog, tenant]);

  useEffect(() => {
    if (location && posthog) {
      posthog.capture("$pageview");
    }
  }, [posthog, location]);

  return (
    <PostHogProviderRoot
      apiKey={apiKey}
      options={{
        api_host: apiHost,
        session_recording: {
          maskAllInputs: false,
          maskInputOptions: {
            password: true,
            email: true,
          },
          ...settings?.session_recording,
        },
        ...settings,
      }}
    >
      {children}
    </PostHogProviderRoot>
  );
};

export default PostHogProvider;
